import React from 'react';


class Step4 extends React.Component{

    constructor(props){
        super(props);
        this.openChecklist = this.openChecklist.bind(this);
    }

    openChecklist(){
        console.log('Open overlay');
    }

    render(){
        return <div className="seehi_step">
            <h2>Aan de slag</h2>
            <p>Subsidie kunt u aanvragen nadat het werk is voltooid. Houd voorafgaande aan de uitvoering rekening met de voorwaarden voor de subsidieaanvraag. Er zijn bijvoorbeeld eisen voor de minimale isolatiewaarden en geïsoleerde oppervlakte voor elke maatregel. Ook moet u over uitvoerdersformulieren en foto’s van de uitvoering beschikken bij de subsidieaanvraag. Gebruik de checklist om te voorkomen dat u iets vergeet.</p>
            {/* <span className="seehi_actionButton" onClick={this.openChecklist}>Checklist openen</span> */}
            <h3>Checklist: dit heeft u nodig van de uitvoering bij de subsidieaanvraag</h3>
            <ul className="seehi_checklist">
                <li>Ingevulde en ondertekende uitvoerdersformulier(en) door het bouwbedrijf</li>
                <li>Een bewijs van inschrijving van het bouwbedrijf in de Kamer van Koophandel</li>
                <li>Foto’s van de uitvoering. In het uitvoerdersformulier worden de foto’s van de uitvoering geupload</li>
                <li>Facturen en betaalbewijzen van de uitvoering</li>
            </ul>

            <h3>Meer informatie</h3>
            <ul className="seehi_linklist">
                <li><a href="https://www.energiebesparendoejenu.nl" target="_blank">Energie besparen doe je nu</a><br />
                    <em>Deze website zet alle mogelijkheden op een rij voor het verminderen van het energieverbruik in woningen.</em>
                </li>
            </ul>
        </div>;
    }
}

export default Step4;


// WEBPACK FOOTER //
// ./src/steps/step4.js